/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { DeliveryWindow } from './DeliveryWindow';
// @ts-ignore
import {
// @ts-ignore
    DeliveryWindowFromJSON,
// @ts-ignore
    DeliveryWindowFromJSONTyped,
// @ts-ignore
    DeliveryWindowToJSON,
} from './DeliveryWindow';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { SupplierAddress } from './SupplierAddress';
// @ts-ignore
import {
// @ts-ignore
    SupplierAddressFromJSON,
// @ts-ignore
    SupplierAddressFromJSONTyped,
// @ts-ignore
    SupplierAddressToJSON,
} from './SupplierAddress';

/**
 * 
 * @export
 * @interface Supplier
 */
export interface Supplier {
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    externalCode?: string;
    /**
     * Contextual field – customer code specific to the supplier-store relation
     * @type {string}
     * @memberof Supplier
     */
    customerCode?: string;
    /**
     * Contextual field – minimum order quantity specific to the supplier-store relation
     * @type {number}
     * @memberof Supplier
     */
    moq?: number;
    /**
     * Use the format "1d" for 1 day, "30d" for 30 days, etc.
     * @type {string}
     * @memberof Supplier
     */
    creditTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    currencyCode: string;
    /**
     * 
     * @type {Status}
     * @memberof Supplier
     */
    status: Status;
    /**
     * 
     * @type {Array<SupplierAddress>}
     * @memberof Supplier
     */
    addresses: Array<SupplierAddress>;
    /**
     * 
     * @type {Array<DeliveryWindow>}
     * @memberof Supplier
     */
    deliveryWindows: Array<DeliveryWindow>;
    /**
     * 
     * @type {Date}
     * @memberof Supplier
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Supplier
     */
    createdByStoreId?: string;
}

/**
 * Check if a given object implements the Supplier interface.
 */
// @ts-ignore
export function instanceOfSupplier(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "addresses" in value;
    isInstance = isInstance && "deliveryWindows" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierFromJSON(json: any): Supplier {
    return SupplierFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): Supplier {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'organizationId': json['organization_id'],
        'name': json['name'],
        'email': json['email'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'customerCode': !exists(json, 'customer_code') ? undefined : json['customer_code'],
        'moq': !exists(json, 'moq') ? undefined : json['moq'],
        'creditTerm': !exists(json, 'credit_term') ? undefined : json['credit_term'],
        'currencyCode': json['currency_code'],
        'status': StatusFromJSON(json['status']),
        'addresses': ((json['addresses'] as Array<any>).map(SupplierAddressFromJSON)),
        'deliveryWindows': ((json['delivery_windows'] as Array<any>).map(DeliveryWindowFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'createdByStoreId': !exists(json, 'created_by_store_id') ? undefined : json['created_by_store_id'],
    };
}

// @ts-ignore
export function SupplierToJSON(value?: Supplier | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'organization_id': value.organizationId,
        'name': value.name,
        'email': value.email,
        'external_code': value.externalCode,
        'customer_code': value.customerCode,
        'moq': value.moq,
        'credit_term': value.creditTerm,
        'currency_code': value.currencyCode,
        'status': StatusToJSON(value.status),
        'addresses': ((value.addresses as Array<any>).map(SupplierAddressToJSON)),
        'delivery_windows': ((value.deliveryWindows as Array<any>).map(DeliveryWindowToJSON)),
        'created_at': (value.createdAt.toISOString()),
        'created_by_store_id': value.createdByStoreId,
    };
}

